import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '@/components/common/SEO';
import { NotificationFilters } from '@/components/client/notification/NotificationFilters';
import { NotificationList } from '@/components/client/notification/NotificationList';
import {
  useMarkAllNotificationsRead,
  useMarkNotificationRead,
  useNotificationList,
} from '@/hooks/useNotifications';
import type { NotificationCategory, PlayerNotification } from '@/services/notificationService';

function NotificationContent() {
  const navigate = useNavigate();
  const [category, setCategory] = useState<NotificationCategory>('all');
  const { data, isLoading } = useNotificationList(category);
  const markOne = useMarkNotificationRead();
  const markAll = useMarkAllNotificationsRead();
  const items = data?.items ?? [];

  const openItem = (item: PlayerNotification) => {
    void markOne.mutateAsync(item.id);
    if (item.actionPath?.startsWith('/')) {
      navigate(item.actionPath);
      return;
    }
    navigate('/notification');
  };

  return (
    <div className="px-4 py-4">
      <div className="flex justify-end mb-3">
        <button
          type="button"
          onClick={() => markAll.mutate()}
          className="text-sm font-semibold text-[#FC480D] cursor-pointer"
        >
          Tandai dibaca
        </button>
      </div>
      <NotificationFilters value={category} onChange={setCategory} />
      <div className="mt-4">
        {isLoading ? (
          <p className="text-sm text-gray-400 text-center py-10">Memuat notifikasi...</p>
        ) : items.length === 0 ? (
          <p className="text-sm text-gray-400 text-center py-10">Belum ada notifikasi</p>
        ) : (
          <NotificationList items={items} onOpen={openItem} />
        )}
      </div>
      <p className="text-center text-xs text-gray-400 mt-8 pb-6">Notifikasi disimpan selama 30 hari</p>
    </div>
  );
}

export default function NotificationPage() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#0E1726]">
      <SEO title="Notifikasi | Sporto" description="Inbox notifikasi pemain Sporto" />
      <div className="block lg:hidden">
        <NotificationContent />
      </div>
      <div className="hidden lg:block">
        <div className="max-w-lg mx-auto">
          <NotificationContent />
        </div>
      </div>
    </div>
  );
}
